export const CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST = 'AccountPaymentMethodList'
export const CACHE_TAG_ACCOUNT_PAYMENT_TRANSACTION_LIST = 'AccountPaymentTransactionList'
export const CACHE_TAG_ACCOUNT_PAYMENT_DETAILS = 'AccountPaymentDetails'

export const CACHE_TAG_TYPES = [
  CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST,
  CACHE_TAG_ACCOUNT_PAYMENT_TRANSACTION_LIST,
  CACHE_TAG_ACCOUNT_PAYMENT_DETAILS,
]
